/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
  homeCompanyList: [],
  companyList:[],
  pagination: {},
  companyJobs:[],
  hopeJobs:[],

};
const getters = {};
const actions = {
  /**
   * 首页公司列表
   * @param data
   * @return {Promise.<void>}
   */
  async getHomeCompany({commit}) {
    const { data } = await request({
      url: `/portal/companies/hot`
    });
    commit("setState", { key: "homeCompanyList", data: data });
  },

  /**
   * 公司列表
   * @param data
   * @return {Promise.<void>}
   */
  async getCompany({commit},params) {
    const { data,pagination } = await request({
      url: `/portal/companies/list`,
      params
    });
    commit("setState", { key: "companyList", data: data });
    if (data) {
      commit("setState", { key: "pagination", data: pagination });
    }
  },

    /**
   * 公司详情
   * @param data
   * @return {Promise.<void>}
   */
    async getCompanyDetail({},id) {
      const { data } = await request({
        url: `/portal/companies/${id}`,
      });
      return data;
    },

  /**
   * 根据公司赛选出职位类别
   * @param data
   * @return {Promise.<void>}
   */
  async getCompanyJob({ commit }, id) {
    const {data} =  await request({
      url: `/portal/companies/positionKind/${id}`,
    });
    commit("setState", { key: "companyJobs", data: data });
  },

   /**
   * 获取用户的期望职位
   * @param data
   * @return {Promise.<void>}
   */
   async getHopeJob({ commit }) {
    const {data} =  await request({
      url: `/portal/job-seekers/desire`,
    });
    commit("setState", { key: "hopeJobs", data: data });
  },



  
};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  },
 
};

export default {
  state,
  getters,
  actions,
  mutations
};
